'use strict';
var Shopify = Shopify || {},
  _ = ORW.utilities._,
  ProductJS = Backbone.View.extend({
    selectors: {
      productJSON: '[data-product-json]',
      plusSizeItem: '[data-plus-size-item]',
      saleItem: '[data-sale-item]',
    },
    initialize: function (t) {
      console.log('init PDP ...');
      (this.$body = $('body')),
        (this.productJSON =
          t.productJSON ||
          (!!this.$(this.selectors.productJSON).length &&
            JSON.parse(this.$(this.selectors.productJSON).html()))),
        (this.$item = $('#product-item-' + this.productJSON.id)),
        this.initFreeShippingTooltip(),
        this.watchVariantStock(),
        this.initGallery(),
        this.initSelects(),
        // this.initStickyAddToBag(),
        (this.addToCart = AddToCart.init({
          productJSON: this.productJSON,
          prefix: '#product-wrap',
        }));
      var e = this.addToCart.optionSelectors.swatches;
      this.$item.parent().is(this.selectors.plusSizeItem)
        ? this.autoselectVariant({
            test: function (t) {
              return /^\d/.test(t);
            },
            field: ['options', e.$sizes.optionIndex],
            selectSize: !0,
          })
        : this.$item.parent().is(this.selectors.saleItem)
        ? this.autoselectVariant({
            test: function (t) {
              return t.compare_at_price > t.price;
            },
            field: [],
            selectSize: !1,
          })
        : this.autoselectVariant({
            test: function () {
              return !0;
            },
            field: [],
            selectSize: !1,
          });
    },
    events: {
      'click .size-chart-link': function (t) {
        t.preventDefault(), this.initSizeChart(t.currentTarget);
      },
    },
    autoselectVariant: function (t) {
      var e = t.test,
        i = t.field,
        s = t.selectSize,
        o = this.productJSON.variants.find(function (t) {
          var s = i.reduce(function (t, e) {
            return t[e];
          }, t);
          return e(s);
        }),
        n = this.addToCart.optionSelectors.swatches,
        r = n.$colors.filter(function () {
          return this.title === o.options[n.$colors.optionIndex];
        });
      if (r.length) {
        r.get(0).click();
        var l = n.$sizes.filter(function () {
          return this.title === o.options[n.$sizes.optionIndex];
        });
        l.length && s && l.get(0).click();
      }
    },
    initFreeShippingTooltip: function () {
      var t = this,
        e = $('.free-shipping-note .has-tooltip'),
        i = e.find('.tooltip'),
        s = function () {
          i.addClass('closing'),
            setTimeout(function () {
              return i.removeClass('active closing');
            }, 200);
        };
      e.children('a').on('click', function (e) {
        e.preventDefault(),
          e.stopPropagation(),
          i.addClass('active'),
          t.$body.on('click.free-shipping-tooltip', function (e) {
            $(e.target).closest('.tooltip').length ||
              (t.$body.off('click.free-shipping-tooltip'), s());
          });
      }),
        i.find('.close').on('click', s);
    },
    initSelects: function () {
      var t = this;
      function e(t, e) {
        (this.$item = t),
          (this.$select = $(e)),
          (this.$selectTitle = this.$select.find('.select-title')),
          (this.$selectContent = this.$select.find('.select-content')),
          (this.$selectOptions = this.$selectContent.find('.select-option')),
          this.$selectTitle.on('click.select', this.tryToggleSelect.bind(this)),
          this.$selectOptions.on(
            'click.select',
            this.tryMakeSelection.bind(this)
          ),
          this.$select.on('select.select', this.handleSelected.bind(this)),
          this.$select.on('close.select', this.tryCloseSelect.bind(this)),
          $(window).on('scroll.select', this.tryCloseSelect.bind(this));
      }
      (e.prototype.handleSelected = function (t, e, i) {
        i
          ? this.$selectOptions
              .filter('[data-value="'.concat(i, '"]'))
              .addClass('current')
              .siblings()
              .removeClass('current')
          : this.$selectOptions.removeClass('current');
        var s = this.$selectOptions.filter('.current'),
          o = (s.html() || e) + '<i class="fa fa-angle-down"></i>';
        return (
          this.$selectTitle.html() !== o && this.$selectTitle.html(o),
          this.$selectTitle[s.hasClass('soldout') ? 'addClass' : 'removeClass'](
            'soldout'
          ),
          this
        );
      }),
        (e.prototype.tryCloseSelect = function () {
          var t = this;
          if (
            1 !== this.$selectContent.find('.active').length &&
            this.$select.is('.open:not(.closing), .opening')
          )
            return (
              this.$selectContent.stop(!0).slideToggle({
                complete: function () {
                  t.$select.removeClass('opening closing open');
                },
              }),
              this.$select.removeClass('opening closing').addClass('closing'),
              this
            );
        }),
        (e.prototype.tryToggleSelect = function () {
          var t = this,
            e =
              !(arguments.length > 0 && void 0 !== arguments[0]) ||
              arguments[0];
          if (1 !== this.$selectContent.find('.active').length) {
            var i = !this.$select.is('.open:not(.closing), .opening');
            return (
              this.$selectContent.stop(!0).slideToggle({
                complete: function () {
                  t.$select.removeClass('opening closing'),
                    t.$select[i ? 'addClass' : 'removeClass']('open');
                },
              }),
              this.$select
                .removeClass('opening closing')
                .addClass(i ? 'opening' : 'closing'),
              e &&
                this.$select.siblings('.select').triggerHandler('close.select'),
              this
            );
          }
        }),
        (e.prototype.tryMakeSelection = function (t) {
          if (this.$select.is('.colors, .sizes')) {
            var e = $(t.currentTarget).data('value');
            this.$select.trigger('change.select', [e]);
          }
          return this.tryToggleSelect();
        }),
        (this.selects = this.$item
          .find('.select')
          .has('.select-title + .select-content > .select-option')
          .map(function (i, s) {
            return new e(t.$item, s);
          }));
    },
    initStickyAddToBag: function () {
      var t = document.getElementById('header'),
        e = this.$item.find('.product-form-bottom > .flex');
      if (e.length) {
        var i = e.parent().get(0),
          s = function () {
            return (
              i.getBoundingClientRect().bottom <=
              t.getBoundingClientRect().bottom
            );
          },
          o = s();
        o && e.addClass('sticky'),
          $(window).on(
            'scroll',
            _.throttle(function () {
              s() !== o && e.toggleClass('sticky'), (o = s());
            }, 1e3 / 60)
          );
      }
    },
    watchVariantStock: function () {
      var t = this,
        e = $('.lystrack_BIS'),
        i = $('#add-to-cart-button'),
        s = i.closest('form'),
        o = i.closest('.product-form-bottom').find('select');
      s.on('variant-changed', function (s, n, r, l) {
        +n == +t.productJSON.id &&
          (e.addClass('hide'),
          l && r.available
            ? (o.add(i).attr('disabled', null), i.text(i.data('copy-add')))
            : (o.add(i).attr('disabled', ''),
              l && e.removeClass('hide'),
              i.text(i.data(l ? 'copy-stock' : 'copy-select'))));
      });
    },
    initGallery: function () {
      function t() {
        var t =
          arguments.length > 0 && void 0 !== arguments[0]
            ? arguments[0]
            : '#product-gallery';
        (this.$parent = $(t).closest('[id^="product-item-"]')),
          (this.$ = function (e) {
            return $(t).find(e);
          }),
          (this.$thumbsWrapper = this.$('#thumbs')),
          (this.$productImage = this.$('#active-wrapper .product-image img')),
          this.$productImage.closest('a').on('click', !1),
          this.lazyload().initModelSelectors().initThumbsSlick(),
          this.$parent
            .find('form.add-to-cart-form')
            .on('variant-changed', this.handleVariantChanged.bind(this));
      }
      return (
        (t.sizes = ['xs', 's', 'm', 'l', 'xl']
          .map(function (t) {
            return new RegExp('^'.concat(t), 'i');
          })
          .reverse()),
        (t.compareSizes = function (e, i) {
          return !(
            [e, i]
              .map(function (e) {
                return (
                  parseInt(
                    /^\d/.test(e)
                      ? e
                      : -t.sizes.findIndex(function (t) {
                          return t.test(e);
                        })
                  ) + 4
                );
              })
              .reduce(function (t, e) {
                return e - t;
              }, 0) < 0
          );
        }),
        (t.resizeImageUrl = function (t) {
          var e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : '';
          return t
            .replace(/_\d*x\d*\.(jpe?g|png|gif)/, '.$1')
            .replace(/\.(jpe?g)/, e ? '_'.concat(e, '$&') : '$&');
        }),
        (t.prototype.changeProductImage = function (e) {
          return (
            e || (e = this.getFirstThumb().find('a').attr('href')),
            this.$productImage
              .attr('src', t.resizeImageUrl(e, '1200x'))
              .data('src', t.resizeImageUrl(e, '1200x'))
              .closest('a')
              .attr('href', t.resizeImageUrl(e, '')),
            this.initZoom(),
            this
          );
        }),
        (t.prototype.handleModelChanged = function (t, e, i) {
          var s = $(t.currentTarget);
          if (!s.is('.current')) {
            s.siblings().removeClass('current'), s.addClass('current');
            var o = s.data('model-info'),
              n = o.color,
              r = o.size,
              l = o.name;
            n &&
              this.filterThumbsSlick({ option1: n, option2: r, option4: l }) &&
              this.changeProductImage(),
              s
                .closest('.models')
                .siblings('.model-selector-title')
                .triggerHandler('click');
          }
        }),
        (t.prototype.handleVariantChanged = function (t, e, i) {
          var s = this;
          new RegExp(e).test(this.$parent.attr('id')) &&
            (/usd/i.test(i.option1) ||
              ((this.selectedColor && this.selectedColor === i.option1) ||
                this.$modelSelectors
                  .removeClass('open opening closing')
                  .find('.models')
                  .css('display', 'none'),
              (this.selectedColor = i.option1),
              (this.selectedSize = i.option2),
              console.log(this.selectedColor),
              this.selectedColor &&
                this.filterThumbsSlick(i) &&
                (this.changeProductImage(),
                this.$modelSelectorOptions.each(function (t, e) {
                  s.filterModelSelectorOptions(e, i);
                }))));
        }),
        (t.prototype.initModelSelectors = function () {
          var t = this;
          return (
            (this.$modelSelectors = this.$('.model-selector')),
            (this.$modelSelectorTitles = this.$modelSelectors.map(function () {
              return $(this).find('.model-selector-title');
            })),
            (this.$modelSelectorOptions = this.$modelSelectors.map(function () {
              return $(this).find('.model');
            })),
            this.$modelSelectors.length
              ? ((this.modelsInfo = this.$modelSelectorOptions[0]
                  .map(function () {
                    return $(this).data('model-info');
                  })
                  .get()),
                this.$modelSelectorOptions.each(function (e, i) {
                  i.on('click', t.handleModelChanged.bind(t));
                }),
                this)
              : ((this.modelsInfo = []), this)
          );
        }),
        (t.prototype.initThumbsSlick = function () {
          var e = this;
          return (
            this.$thumbsWrapper.on('init', function (i, s) {
              s.$slider.removeClass('slick-pending'),
                e.$modelSelectors.removeClass('hide'),
                s.$slides.find('a').on('click', function (i) {
                  i.preventDefault();
                  var s = $(i.currentTarget).attr('href');
                  t.resizeImageUrl(s, '') !==
                    t.resizeImageUrl(e.$productImage.data('src'), '') &&
                    e.changeProductImage(s);
                });
              var o = s.$slides.eq(0).find('a').attr('href');
              e.changeProductImage(o);
            }),
            (this.$thumbsWrapper = this.$thumbsWrapper.slick({
              arrows: !1,
              vertical: !0,
              verticalSwiping: !0,
              autoplay: !1,
              infinite: !1,
              nextArrow: '<i class="lnr lnr-chevron-right slick-next"></i>',
              prevArrow: '<i class="lnr lnr-chevron-left slick-prev"></i>',
              responsive: [
                {
                  breakpoint: ORW.responsiveSizes.large,
                  settings: {
                    arrows: !0,
                    infinite: !0,
                    slidesToShow: 1,
                    vertical: !1,
                    verticalSwiping: !1,
                  },
                },
              ],
              slidesToScroll: 1,
              slidesToShow: 6,
              speed: 200,
            })),
            this
          );
        }),
        (t.prototype.initZoom = _.throttle(function () {
          var e = this,
            i = t.resizeImageUrl(this.$productImage.data('src'), ''),
            s = function () {
              return e.$productImage.closest('span');
            };
          return (
            s().trigger('zoom.destroy'),
            this.$productImage.find('img.zoomImg').remove(),
            this
          );
        }, 100)),
        (t.prototype.filterThumbsSlick = function (e) {
          var i = e.option1,
            s = e.option2,
            o = e.option4,
            n = this.modelsInfo.filter(function (t) {
              return t.color === i;
            }),
            r = n[0];
          if (void 0 !== o)
            r = n.find(function (t) {
              return t.name === o;
            });
          else {
            var l = n.slice().sort(function (e, i) {
              var s = e.size,
                o = i.size;
              return s === o ? 0 : t.compareSizes(o, s) ? 1 : -1;
            });
            if (_.isEqual(n, l))
              r =
                n
                  .filter(function (e) {
                    return t.compareSizes(e.size, s);
                  })
                  .filter(function (t, e, i) {
                    var s = t.size;
                    return (
                      i.findIndex(function (t) {
                        return t.size === s;
                      }) === e
                    );
                  })
                  .pop() || n[0];
            o = r && r.name;
          }
          s = r && r.size;
          var c = this.getFirstThumb().data('model-info'),
            a = c.color,
            d = c.size,
            h = c.name;
          if (a === i && d === s && h === o) {
            var u = this.$thumbsWrapper.slick('getSlick');
            if (u.$slidesCache && u.$slidesCache.length !== u.$slides.length)
              return !1;
          }
          return (
            this.$thumbsWrapper
              .slick('slickUnfilter')
              .slick('slickFilter', function () {
                var t = $(this).data('model-info'),
                  e = t.color,
                  n = t.size,
                  r = t.name;
                return e === i && n === s && r === o;
              }),
            this
          );
        }),
        (t.prototype.filterModelSelectorOptions = function (t, e) {
          var i = e.option1,
            s = (e.option2, this.getFirstThumb().data('model-info'));
          t.removeClass('active')
            .removeClass('current')
            .filter(function () {
              var t = $(this).data('model-info').color;
              return new RegExp('^'.concat(t, '$'), 'i').test(i);
            })
            .addClass('active')
            .filter(function () {
              var t = $(this).data('model-info'),
                e = t.name,
                i = t.size;
              return e === s.name && i === s.size;
            })
            .addClass('current');
          t.is('.current') || t.filter('.active').first().addClass('current');
          var o = t.filter('.active');
          return (
            this.$modelSelectorTitles.each(function (t, e) {
              var i = 1 === o.length ? o.text() : e.data('default-content');
              e.html() !== i && e.html(i),
                e.css('cursor', 1 === o.length ? 'default' : '');
            }),
            this
          );
        }),
        (t.prototype.getFirstThumb = function () {
          return this.$thumbsWrapper
            .find('.slick-slide')
            .filter(function (t, e) {
              return e.dataset.slickIndex >= 0;
            })
            .first();
        }),
        (t.prototype.lazyload = function () {
          return (
            this.$('[data-src]').each(function () {
              $(this).attr('src', $(this).data('src'));
            }),
            this.$('[data-srcset]').each(function () {
              $(this).attr('srcset', $(this).data('srcset'));
            }),
            this
          );
        }),
        (window.Gallery = t),
        new t()
      );
    },
    initSizeChart: function (t) {
      var e = this,
        i = $(t).attr('href');
      return (
        $('#loading-overlay').show(),
        (modal = new tingle.modal({
          closeMethods: ['overlay', 'button', 'escape'],
          closeLabel: 'Close',
          cssClass: ['size-chart-popup'],
        })),
        $.ajax({ url: i }).success(function (t) {
          $('#loading-overlay').hide(), modal.setContent(t);
          var i = e.productJSON.tags
              .join(',')
              .toLowerCase()
              .replace('style:shapewear', '')
              .match(/style:(\w+)/i),
            s =
              ".size-chart .nav .selector[data-tab='" +
              (i
                ? i[1]
                    .replace(/(tops|tees|camis|bodysuits)/, 'tanks')
                    .replace(/(pants)/, 'jeans')
                : 'bottoms') +
              "']";
          console.log('DATA TAB: ', s), modal.open(), $(s).click();
        }),
        !1
      );
    },
    destroy: function () {
      this.undelegateEvents();
    },
    isMobile: function () {
      return 'small' === ORW.responsive;
    },
  });
